// Tenant kodi — abonentdan SO'RALMAYDI.
//
// Backend (`LoginController`) uni majburiy talab qiladi, chunki
// `subscriber.login` faqat TENANT ICHIDA unikal (`UNIQUE (tenant_id, login)`),
// butun o'rnatma bo'ylab emas — bir xil "ahmad" logini ikki tashkilotda ikki
// mustaqil abonentga tegishli bo'lishi mumkin. Lekin bu backend talabi,
// UI TALABI EMAS: amalda kabinet ikkita tenant uchun ishlaydi (`af-isp`,
// `uz-venue`), shuning uchun kod o'z tenant'ini OLDINDAN bilishi kerak —
// lekin BUILD vaqtida emas (pastga qarang).
//
// Uch manba, shu tartibda:
//   1. `window.__XSIB_SELFCARE_TENANT_CODE__` — ISH VAQTIDA (runtime)
//      `public/config.js` ga entrypoint tomonidan yoziladi (xsib-admin
//      naqshi, `shared/api/client.ts`dagi API manzili bilan bir xil usul).
//      ⚠️ NEGA bu birinchi va NEGA `VITE_TENANT_CODE` YETARLI EMAS:
//      Vite `VITE_*` o'zgaruvchilarini BUILD paytida kod ichiga qotirib
//      qo'yadi. Agar tenant shunday kirsa, bitta image FAQAT bitta
//      tenant uchun yaroqli bo'lib qoladi va har tenant uchun alohida
//      image qurish kerak bo'ladi — "staging'da sinalgan aynan shu
//      artefakt prod'ga chiqadi" tamoyili buziladi. Runtime yozuv esa
//      bitta image'ni ikkala tenant (`af-isp`, `uz-venue`) uchun
//      qayta ishlatishga imkon beradi — deploy vaqtida `docker-entrypoint.sh`
//      `XSIB_TENANT_CODE` muhit o'zgaruvchisidan `config.js` ga yozadi.
//   2. `VITE_TENANT_CODE` — build vaqtida belgilangan (lokal `npm run dev`
//      yoki `preview` uchun qulaylik, konteynerlashtirilgan deploy'da
//      ishlatilmaydi)
//   3. `window.location.hostname` ning birinchi bo'lagi — subdomen bo'yicha
//      deploy qilinganda ("af-isp.x-sib.uz" → "af-isp")
//
// Uchalasi ham bo'lmasa — bu KONFIGURATSIYA XATOSI, jimgina `undefined`
// yuborilmaydi: login sahifasi buni aniq ko'rsatishi kerak.

declare global {
  interface Window {
    __XSIB_SELFCARE_TENANT_CODE__?: string
  }
}

function detectFromHostname(): string | null {
  if (typeof window === 'undefined') return null
  const host = window.location.hostname
  const parts = host.split('.')
  const first = parts[0]
  // "localhost" yoki IP (127.0.0.1) — bu subdomen emas, aniqlash imkonsiz.
  // Kamida ikki bo'lakli host ("af-isp.x-sib.uz") kerak, bitta bo'lak
  // ("localhost", "af-isp" o'zi) tenant kodi emas, butun host nomi.
  if (parts.length < 2 || !first || first === 'localhost' || /^\d+$/.test(first)) {
    return null
  }
  return first
}

const runtimeCode = typeof window !== 'undefined' ? window.__XSIB_SELFCARE_TENANT_CODE__?.trim() : undefined
const envCode = import.meta.env.VITE_TENANT_CODE?.trim()
const TENANT_CODE: string | null = runtimeCode ? runtimeCode : envCode ? envCode : detectFromHostname()

export class TenantConfigError extends Error {
  constructor() {
    super("Kabinet noto'g'ri sozlangan: tenant kodi aniqlanmadi")
    this.name = 'TenantConfigError'
  }
}

/** Tenant kodi ma'lummi — login sahifasi so'rov yubormasdan oldin tekshiradi */
export function hasTenantConfig(): boolean {
  return TENANT_CODE !== null
}

/** Tenant kodi — yo'q bo'lsa `TenantConfigError` otadi, jimgina `undefined` yubormaydi */
export function requireTenantCode(): string {
  if (!TENANT_CODE) throw new TenantConfigError()
  return TENANT_CODE
}
